export const ADD_NOTIFICATION = "notifications.ADD_NOTIFICATION";
export const CLOSE_NOTIFICATION = "notifications.CLOSE_NOTIFICATION";
